<template>
  <div data-cy="quote">
    <template v-if="hasMatchingInsuranceCompany">
      <Hero :title="$t('message.hero.yourQuote')" :text="`${firstName}, ${$t('message.hero.yourQuoteText')}`"></Hero>
      <component :insuranceQuotes="insuranceQuotes" :is="ratesComponentName"></component>
    </template>
    <template v-else>
      <div class="no-results text-center mx-auto my-5">
        <img :src="require('@/assets/error-general.svg')" width="61" height="61" alt="" />
        <h1 class="mt-3 h2">{{ $t('message.insurance.noResults.title') }}</h1>
        <p>{{ $t('message.insurance.noResults.msg') }}</p>
      </div>
    </template>
    <NextStep v-if="subscribesToCredit" :hasMatchingInsuranceCompany="hasMatchingInsuranceCompany"></NextStep>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Hero from '@/components/insurance/hero/Hero.vue';
import NextStep from '@/components/insurance/NextStep.vue';
import VerticalRates from '@/components/insurance/VerticalRates.vue';
import HorizontalRates from '@/components/insurance/HorizontalRates.vue';

export default {
  name: 'Quote',
  components: {
    Hero,
    NextStep,
    VerticalRates,
    HorizontalRates,
  },
  computed: {
    ...mapState('user', ['firstName']),
    ...mapState('insurance', ['quotes']),
    ...mapGetters('business', ['getSupported', 'getThisIsAmerica', 'getSubscribedProducts']),
    subscribesToCredit() {
      return this.getSubscribedProducts.indexOf('credit') >= 0;
    },
    ratesComponentName() {
      return this.isAVRDesktop ? 'HorizontalRates' : 'VerticalRates';
    },
    insuranceQuotes() {
      if (this.getThisIsAmerica && this.quotes.length > 0) {
        return this.quotes.slice(0, 3);
      }

      const canadianQuotes =
        this.quotes.length > 0
          ? this.quotes.filter(company => this.getSupported.InsuranceStrip.includes(company.InsuranceCompany))
          : [];
      const halIndex = canadianQuotes.findIndex(quote => quote.InsuranceCompany === 'HAL');
      const wuIndex = canadianQuotes.findIndex(quote => quote.InsuranceCompany === 'WU');
      if (halIndex >= 0 && wuIndex >= 0) {
        // We got quotes back from HAL and WU (both Intact Insurance)
        if (canadianQuotes[wuIndex].Annual < canadianQuotes[halIndex].Annual) {
          canadianQuotes.splice(halIndex, 1); // Remove HAL
        } else {
          canadianQuotes.splice(wuIndex, 1); // Remove WU
        }
      }

      return canadianQuotes;
    },
    hasMatchingInsuranceCompany() {
      return this.insuranceQuotes.length > 0;
    },
  },
  mounted() {
    this.$store.commit('SET_DHS_STATE', ['insurance', 'complete']);
  },
};
</script>

<style lang="scss" scoped>
.no-results {
  max-width: 415px;
}
</style>
